import { FaStar, FaQuoteLeft, FaTrophy, FaPlay, FaUsers, FaChartLine, FaCheckCircle } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi';
import { BsStarFill, BsLightningChargeFill } from 'react-icons/bs';

function TestimonialsSection({ testimonials }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 rounded-3xl p-8 sm:p-12 mb-10">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-gradient-to-br from-emerald-200/30 to-green-300/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-teal-200/30 to-emerald-300/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      
      {/* Header Section */}
      <div className="relative text-center mb-12">
        {/* Top Badge */}
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-green-500 text-white px-5 py-2 rounded-full text-sm font-semibold mb-6 shadow-lg shadow-emerald-500/30">
          <FaTrophy className="text-amber-300" />
          <span>Real Results from Real Business Owners</span>
          <HiSparkles className="text-amber-300" />
        </div>
        
        <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
            Success Stories
          </span>
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Join thousands of business owners who transformed their payment recovery process
        </p>
        
        {/* Stats Row */}
        <div className="flex flex-wrap justify-center gap-6 mt-8">
          <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm">
            <FaUsers className="text-emerald-500" />
            <span className="font-bold text-gray-800">10,000+</span>
            <span className="text-gray-500 text-sm">Trained</span>
          </div>
          <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm">
            <FaChartLine className="text-green-500" />
            <span className="font-bold text-gray-800">₹500 Cr+</span>
            <span className="text-gray-500 text-sm">Recovered</span>
          </div>
          <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm">
            <BsStarFill className="text-amber-500" />
            <span className="font-bold text-gray-800">4.9/5</span>
            <span className="text-gray-500 text-sm">Rating</span>
          </div>
        </div>
      </div>
      
      {/* Testimonials Grid */}
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((testimonial, index) => (
          <div 
            key={index}
            className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-emerald-100/50"
          >
            {/* Card Accent */}
            <div className="absolute top-0 left-6 right-6 h-1 bg-gradient-to-r from-emerald-400 via-green-500 to-teal-400 rounded-full transform origin-left group-hover:scale-x-100 transition-transform duration-500"></div>
            
            {/* Quote Icon Background */}
            <div className="absolute top-4 right-4 w-16 h-16 bg-gradient-to-br from-emerald-100 to-green-100 rounded-full flex items-center justify-center opacity-50 group-hover:opacity-100 transition-opacity">
              <FaQuoteLeft className="text-emerald-400 text-2xl" />
            </div>
            
            {/* User Info */}
            <div className="flex items-center gap-4 mb-5 relative z-10">
              <div className="relative">
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 via-green-500 to-teal-500 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-lg shadow-emerald-500/30 transform rotate-3 group-hover:rotate-6 transition-transform">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center">
                  <FaCheckCircle className="text-white text-xs" />
                </div>
              </div>
              <div>
                <h4 className="font-bold text-gray-800 text-lg group-hover:text-emerald-600 transition-colors">{testimonial.name}</h4>
                <p className="text-gray-500 text-sm flex items-center gap-1">
                  <BsLightningChargeFill className="text-amber-500" />
                  {testimonial.business}
                </p>
              </div>
            </div>
            
            {/* Testimonial Text */}
            <div className="relative pl-4 border-l-3 border-emerald-300 mb-4">
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
            
            {/* Rating */}
            <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <BsStarFill key={i} className="text-amber-400 text-lg" />
                ))}
              </div>
              <span className="text-sm text-emerald-600 font-medium flex items-center gap-1">
                <FaCheckCircle />
                Verified Student
              </span>
            </div>
          </div>
        ))}
      </div>
      
      {/* Bottom CTA */}
     
    </section>
  );
}

export default TestimonialsSection;
